import axios, { Method } from "axios";
import { getToken, removeToken } from "./helperFunctions";
import Cookies from "js-cookie";
import { doctorMode } from "../lib/constans";
import { store } from "../Store/store";
import { removeAuth } from "../Store/reducer";
import { removeAllIndicators } from "../Store/redDots";

const _baseUrl = process.env.REACT_APP_BACKEND_URL;

interface IhttpRequestParams {
  method?: Method;
  path: string;
  params?: Record<string, any> | null;
  baseUrl?: string;
  header?: Record<string, string>;
  token?: string;
}

interface IHttpResponse<T> {
  res?: T;
  err?: any;
  status?: number;
  formErrors?: any;
}

export default async function httpRequest<T = any>({
  header = { "Content-Type": "application/json" },
  method = "get",
  path = "",
  params = null,
  baseUrl = _baseUrl,
  token = getToken(),
}: IhttpRequestParams): Promise<IHttpResponse<T>> {
  // const navigate = useNavigate();
  const headers: Record<string, string> = {
    ...header,
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  try {
    let response;
    if (["post", "put", "patch", "delete"].includes(method)) {
      response = await axios({
        method,
        url: baseUrl + path,
        headers,
        data: params, // Use params as request body
      });
    } else {
      response = await axios({
        method,
        url: baseUrl + path,
        headers,
      });
    }
    return { res: response?.data , status: response?.status};
  } catch (error: any) {
    if (error?.response?.status === 401) {
      Cookies.remove(doctorMode);
      removeToken();
      store.dispatch(removeAuth());
      store.dispatch(removeAllIndicators());
      // navigate("/login");
    }

    console.log("error", error);
    console.log("error?.response?.data", error?.response?.data);
    let errorMessage = error?.response?.data?.message || error?.response?.data?.err || "Error";
    if(error?.response?.data?.error && typeof error?.response?.data?.error === "object"){
      let errorM = Object.values(error?.response?.data?.error).join(", ");
      errorMessage = errorM;
    }
    return {
      err: errorMessage,
      status: error?.response?.status,
      formErrors : error?.response?.data?.error || null,
    };
  }
}
